import { createUseStyles } from 'react-jss'
import { GRAY } from '@omnilert/components'

const useStyles = createUseStyles({
  title: {
    borderBottom: `1px solid ${GRAY}`,
    fontFamily: 'BentonSansBold',
    fontSize: '24px',
    padding: '16px 0 30px 0'
  }
})

export default useStyles
